import script from "./CreateTaskTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateTaskTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CreateTaskTemplate.vue?vue&type=style&index=0&id=7a581198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a581198"]])

export default __exports__